import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { getOrderItems, getOrderTotalPrice, getSelectedVouchers} from 'Store/Order/selectors';
import OrderItemSummary from './OrderItemSummary';
import WrapperBox from 'Components/Shared/WrapperBox/WrapperBox';



interface IProps {
  noWrapper?: boolean;
}

interface IPropsInternal {
  orderItems: Julius.Website.OrderItemViewModel[];
  discountItems: Julius.Website.VoucherViewModel[];
  totalPrice: number;
}

type Props = IProps & IPropsInternal;

class OrderItemSummaryContainer extends React.PureComponent<Props> {
  render() {

    if (this.props.noWrapper) {
      return (
        <OrderItemSummary 
          orderItems={ this.props.orderItems }
          discountItems={ this.props.discountItems }
          totalPrice={ this.props.totalPrice }
        />
      );
    }
    
    return (
      <WrapperBox>
        <OrderItemSummary 
          orderItems={ this.props.orderItems }
          discountItems={ this.props.discountItems }
          totalPrice={ this.props.totalPrice }
        />
      </WrapperBox>
    
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    orderItems: getOrderItems(state),
    discountItems: getSelectedVouchers(state),
    totalPrice: getOrderTotalPrice(state),
  };
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, null),
)(OrderItemSummaryContainer);


// WEBPACK FOOTER //
// ./src/components/OrderItemSummary/OrderItemSummaryContainer.tsx